const DonationsRawTable = ({ rows, headers }) => (
  <div className="overflow-x-auto max-h-[60vh] overflow-y-auto mt-6">
    <table className="w-full text-sm">
      <thead className="sticky top-0">
        <tr className="bg-primary-100">
          {headers.map((header) => (
            <th key={header} className="p-2 text-left whitespace-nowrap">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx} className="border-t even:bg-neutral-50">
            {headers.map((header) => (
              <td key={header} className="p-2 whitespace-nowrap">
                {row[header] ?? "—"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DonationsRawTable;
